import React, { useState, useEffect } from "react";
import {
  Table,
  UncontrolledDropdown,
  Input,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Button,
  Label,
  Row,
  Col,
} from "reactstrap";
import PropTypes from "prop-types";

import style from "../../Grid.module.scss";
import { getAccountType, BankAccountType, BankAccountStatus } from "../types";
import ModalConfirm from "../../Modal/ModalConfirm";
import ModalBankAccount from "../ModalAccountBankAccount";
import { CircularProgress } from "../../../..";
import { AccountMode } from "../../../../utils/Helper";

function generateEmptyBankAccount() {
  return {
    BankAccountId: "",
    BankAccountItemId: "",
    BankAccountName: "",
    BankAccountHolders: undefined,
    BankAccountBranch: undefined,
    BankAccountNumber: undefined,
    BankAccountCurrency: 1,
    BankAccountIsDepositInterest: false,
    BankAccountPersonalName: "",
    BankAccountObs: "",
    BankAccountType: BankAccountType.Savings,
    BankAccountStatus: BankAccountStatus.Active,
    Archives: [],
  };
}

const BankAccountsTab = ({
  accountId,
  bankAccounts,
  currencies,
  banks,
  setAccountData,
  services,
  isReadOnly,
  mode,
  setRedirectAccounts,
  sended,
  references,
  signatureSets,
  groups,
  riskByPersonIsZero,
  isMainHolderJuridical,
}) => {
  const [fetching, setFetching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    bankAccountItemId: undefined,
    saving: false,
    callback: undefined,
  });
  const [modalBankAccount, setModalBankAccount] = useState({
    open: false,
    saving: false,
    bankAccount: generateEmptyBankAccount(),
    errors: {},
  });
  const [archives, setArchives] = useState([]);
  const [onlyMainHolderAccounts, setOnlyMainHolderAccounts] = useState(true);

  const reloadBankAccounts = () => {
    if (mode === AccountMode.New) {
      if (!fetching) {
        const body = {
          AccountGetInfo: {
            GetAccountDataId: accountId,
            GetAccountDataOnboardingId: accountId,
            GetAccountDataType: getAccountType.BankAccounts,
          },
        };
        services.fetchNewAccountInfo(body, (response) => {
          if (response && response.SDTAccount) {
            setAccountData(
              {
                AccountId: accountId,
                BankAccounts: response.SDTAccount.BankAccounts,
              },
              false
            );
          }
          setFetching(false);
        });
        setFetching(true);
      }
    }
  };
  const toggleModalConfirm = () => {
    setModalConfirm({
      open: false,
      title: "",
      bankAccountItemId: undefined,
      saving: false,
      callback: undefined,
    });
  };

  const onChangeEdit = (name, value, strValue) => {
    let newValue = value;
    if (name === "BankAccountIsDepositInterest" || name === "BankAccountFavorite") {
      newValue = value === "true" || value === true;
    }
    const errors = validateBankAccount({
      ...modalBankAccount.bankAccount,
      [name]: newValue,

      BankAccountName: name === "BankAccountId" ? strValue : modalBankAccount.bankAccount.BankAccountName,
    });
    setModalBankAccount({
      ...modalBankAccount,
      bankAccount: {
        ...modalBankAccount.bankAccount,
        [name]: newValue,

        BankAccountName: name === "BankAccountId" ? strValue : modalBankAccount.bankAccount.BankAccountName,
      },
      errors: errors,
    });
  };

  const toggleModalBankAccount = (bankAccount) => {
    if (bankAccount !== undefined) {
      if (bankAccount.Archives !== undefined) {
        setArchives(bankAccount.Archives);
      } else {
        setArchives([]);
      }
    } else {
      setArchives([]);
    }
    setModalBankAccount({
      saving: modalBankAccount.saving,
      open: !modalBankAccount.open,
      bankAccount: bankAccount && bankAccount.BankAccountItemId ? bankAccount : generateEmptyBankAccount(),
      errors: {},
    });
  };

  const handleEdit = (index) => {
    toggleModalBankAccount(bankAccounts[index]);
  };

  const handleAdd = () => {
    toggleModalBankAccount();
  };

  const handleDelete = (index) => {
    const id = bankAccounts[index].BankAccountItemId;
    const bankId = bankAccounts[index].BankAccountId;
    setModalConfirm({
      open: true,
      title: "Are you sure you want to delete the selected Bank Account?",
      bankAccountItemId: id,
      callback: () => deleteBankAccount(id, bankId),
    });
  };

  function validateBankAccount(fields) {
    const fieldNames = [
      "BankAccountId",
      "BankAccountPersonalName",
      "BankAccountHolders",
      "BankAccountNumber",
      "BankAccountCurrency",
      "BankAccountStatus",
    ];
    const errors = {};

    fieldNames.forEach((name) => {
      if (fields[name] == undefined || fields[name] == "") {
        errors[name] = "Required field";
      }
    });

    return errors;
  }

  const handleSaveBankAccount = () => {
    const errors = validateBankAccount(modalBankAccount.bankAccount);
    setModalBankAccount({
      ...modalBankAccount,
      errors: errors,
    });
    if (Object.keys(errors).length == 0) {
      const newBankAccount = { ...modalBankAccount.bankAccount };
      const account = {
        AccountId: accountId,
        AccountOnboardingId: accountId,
        BankAccounts: [
          {
            ...newBankAccount,
            DeleteBankAccount: false,
            Archives: archives,
          },
        ],
      };
      const body = {
        accountChangeType: getAccountType.BankAccounts,
        account,
      };
      setModalBankAccount({ ...modalBankAccount, saving: true });
      if (mode !== AccountMode.New) {
        services.fetchAccountUpdate(body, (response) => {
          if (response && response.result && response.result.Code === 200) {
            const newBankAccounts = [...bankAccounts];
            let index = -1;
            newBankAccounts.map((bankAcc, i) => {
              if (newBankAccount.BankAccountItemId === bankAcc.BankAccountItemId) {
                index = i;
              }
              return {};
            });
            if (index > -1) {
              newBankAccounts[index] = newBankAccount;
            } else {
              newBankAccounts.push(newBankAccount);
            }
            account.BankAccounts = newBankAccounts;
            setAccountData(account, true);
            setModalBankAccount({
              saving: false,
              open: false,
              bankAccount: generateEmptyBankAccount(),
              errors: {},
            });
          } else {
            setModalBankAccount({
              ...modalBankAccount,
              saving: false,
            });
            alert(response.result.Description);
          }
        });
      } else {
        services.fetchNewAccount(body, (response) => {
          if (response && response.result && response.result.Code === 200) {
            const newBankAccounts = [...bankAccounts];
            let index = -1;
            newBankAccounts.map((bankAcc, i) => {
              if (newBankAccount.BankAccountItemId === bankAcc.BankAccountItemId) {
                index = i;
              }
              return {};
            });
            if (index > -1) {
              newBankAccounts[index] = newBankAccount;
            } else {
              newBankAccounts.push(newBankAccount);
            }
            account.BankAccounts = newBankAccounts;
            setAccountData(account, true);
            reloadBankAccounts();
            setModalBankAccount({
              saving: false,
              open: false,
              bankAccount: generateEmptyBankAccount(),
              errors: {},
            });
          } else {
            setModalBankAccount({
              ...modalBankAccount,
              saving: false,
            });
          }
        });
      }
    }
  };

  const deleteBankAccount = (id, bankId) => {
    const deleteAccountId = id;
    const account = {
      AccountId: accountId,
      AccountOnboardingId: accountId,
      BankAccounts: [
        {
          BankAccountItemId: deleteAccountId,
          BankAccountId: bankId,
          DeleteBankAccount: true,
        },
      ],
    };
    const body = {
      account,
      accountChangeType: getAccountType.BankAccounts,
    };
    setModalConfirm({ ...modalConfirm, saving: true });
    if (mode !== AccountMode.New) {
      services.fetchAccountUpdate(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          const newBankAccounts = bankAccounts;
          let index = -1;
          newBankAccounts.map((bankAcc, i) => {
            if (deleteAccountId === bankAcc.BankAccountItemId) {
              index = i;
            }
            return {};
          });
          if (index > -1) {
            newBankAccounts.splice(index, 1);
          }
          account.BankAccounts = newBankAccounts;
          setAccountData(account, true);
          toggleModalConfirm();
        } else {
          setModalConfirm({
            ...modalConfirm,
            saving: false,
          });
          alert(response.result.Description);
        }
      });
    } else {
      services.fetchNewAccount(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          const newBankAccounts = bankAccounts;
          let index = -1;
          newBankAccounts.map((bankAcc, i) => {
            if (deleteAccountId === bankAcc.BankAccountItemId) {
              index = i;
            }
            return {};
          });
          if (index > -1) {
            newBankAccounts.splice(index, 1);
          }
          account.BankAccounts = newBankAccounts;
          setAccountData(account, true);
          reloadBankAccounts();
          toggleModalConfirm();
        } else {
          setModalConfirm({
            ...modalConfirm,
            saving: false,
          });
        }
      });
    }
  };

  const handleCreateAccount = () => {
    setLoading(true);
    const body = {
      onboardingProcessId: accountId,
    };
    services.createAccount(body, (data) => {
      if (data && data.result) {
        setModalConfirm({
          ...modalConfirm,
          saving: false,
          open: false,
        });
        if (data.result.Code === 200) {
          alert("Account Sended to Compliance!");
          setRedirectAccounts(true);
        } else {
          alert(`Failed! ${data.result.Description}`);
        }
      }
      setLoading(false);
    });
  };

  const createOnboardingAccount = () => {
    setModalConfirm((m) => ({
      ...m,
      open: true,
      title: "Are you sure you want to send this account to compliance?",
      accountId,
      callback: () => handleCreateAccount(accountId),
    }));
  };

  const getCurrencyISO = (id) => {
    let iso = "";
    if (currencies) {
      currencies.forEach((c) => {
        if (parseInt(c.currencyId, 10) === parseInt(id, 10)) {
          iso = c.currencyISO;
        }
      });
    }
    return iso;
  };

  useEffect(() => {
    if (mode !== AccountMode.New) {
      if (!bankAccounts && !fetching) {
        const body = {
          AccountGetInfo: {
            GetAccountDataId: accountId,
            GetAccountDataType: getAccountType.BankAccounts,
          },
        };
        services.fetchAccountSectorInfo(body, (response) => {
          if (response && response.SDTAccount) {
            setAccountData(
              {
                SignatureSets: signatureSets,
                PersonalReferences: references,
                AccountId: accountId,
                BankAccounts: response.SDTAccount.BankAccounts,
              },
              false
            );
          }
          setFetching(false);
        });
        setFetching(true);
      }
    }
  }, [bankAccounts, fetching, accountId, setAccountData, services]);

  useEffect(() => {
    if (mode === AccountMode.New) {
      if (!fetching) {
        const body = {
          AccountGetInfo: {
            GetAccountDataId: accountId,
            GetAccountDataOnboardingId: accountId,
            GetAccountDataType: getAccountType.BankAccounts,
          },
        };
        services.fetchNewAccountInfo(body, (response) => {
          if (response && response.SDTAccount) {
            setAccountData(
              {
                AccountId: accountId,
                PersonalReferences: references,
                SignatureSets: signatureSets,
                Groups: groups,
                BankAccounts: response.SDTAccount.BankAccounts,
              },
              false
            );
          }
          setFetching(false);
        });
        setFetching(true);
      }
    }
  }, []);

  const getFile = (file) => {
    if (mode === AccountMode.New) {
      const body = {
        fileId: file.ArchiveTemporalFileId,
        onboarding: accountId,
      };
      services.getOnboardingAccountArchive(body, (response) => {
        var a = document.createElement("A");
        a.href = `data:application/octet-stream;base64,${response.blobfile}`;
        a.download = `${file.ArchiveName}.${file.ArchiveExtension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    } else {
      const body = {
        accountId: accountId,
        archiveId: file.ArchiveId,
      };
      services.getAccountArchive(body, (response) => {
        var a = document.createElement("A");
        a.href = `data:application/octet-stream;base64,${response.blobfile}`;
        a.download = `${file.ArchiveName}.${file.ArchiveExtension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    }
  };

  return (
    <div>
      {isMainHolderJuridical && (
        <div
          className={style.showAll}
          style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}
        >
          <Label
            className="switch switch-text switch-pill switch-secondary switch-lg"
            style={{ marginBottom: "0px" }}
          >
            <Input
              type="checkbox"
              className="switch-input"
              onChange={(e) => setOnlyMainHolderAccounts(e.target.checked)}
              defaultChecked={onlyMainHolderAccounts}
              value={onlyMainHolderAccounts}
            />
            <span className="switch-label" data-on="Yes" data-off="No"></span>
            <span className="switch-handle"></span>
          </Label>
          <Label className={style.label} style={{ marginLeft: "8px" }}>
            Only Main Holder's
          </Label>
        </div>
      )}
      <Table className={style.table}>
        <thead>
          <tr>
            <th style={{ maxWidth: 50 }}> </th>
            <th style={{ maxWidth: 70 }}>#</th>
            <th>Currency</th>
            <th>Type</th>
            <th>Name</th>
            <th>Holders</th>
            <th>Default Permanent Instruction</th>
            <th>Fund Incomes only</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {fetching ? (
            <tr>
              <td colSpan={5}>
                <CircularProgress sm />
              </td>
            </tr>
          ) : (
            <React.Fragment>
              {bankAccounts && bankAccounts.length > 0 ? (
                bankAccounts
                  .filter(
                    (acc) =>
                      !isMainHolderJuridical || !onlyMainHolderAccounts || acc.BankAccountFromMainHolder
                  )
                  .map((acc, i) => (
                    <tr key={acc.BankAccountItemId}>
                      <td style={{ width: 50 }}>
                        {riskByPersonIsZero && (
                          <RenderDropdownActions index={i} onDelete={handleDelete} onEdit={handleEdit} />
                        )}
                      </td>
                      <td style={{ width: 70 }}>{acc.BankAccountNumber}</td>
                      <td>{getCurrencyISO(acc.BankAccountCurrency)}</td>
                      <td>{acc.BankAccountType}</td>
                      <td>{acc.BankAccountName}</td>
                      <td>{acc.BankAccountHolders}</td>
                      <td>{acc.BankAccountIsDepositInterest ? "Yes" : "No"}</td>
                      <td>{acc.BankAccountFundIncomesOnly ? "Yes" : "No"}</td>
                      <td>{acc.BankAccountStatus}</td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center" }}>
                    No Results.
                  </td>
                </tr>
              )}
            </React.Fragment>
          )}
        </tbody>
      </Table>
      {riskByPersonIsZero && !isReadOnly && (
        <Button color="primary" onClick={handleAdd}>
          <i className="fa fa-plus" /> Add Bank Account
        </Button>
      )}
      <ModalConfirm {...modalConfirm} toggle={toggleModalConfirm} />
      <ModalBankAccount
        {...modalBankAccount}
        toggle={toggleModalBankAccount}
        onChange={onChangeEdit}
        onSave={handleSaveBankAccount}
        currencies={currencies}
        banks={banks}
        errors={modalBankAccount.errors}
        archives={archives}
        setArchives={setArchives}
        getFile={getFile}
      />
    </div>
  );
};

BankAccountsTab.propTypes = {
  accountId: PropTypes.string.isRequired,
  bankAccounts: PropTypes.array.isRequired,
  setAccountData: PropTypes.func.isRequired,
  currencies: PropTypes.array.isRequired,
  services: PropTypes.object.isRequired,
  banks: PropTypes.array,
};

BankAccountsTab.defaultProps = {
  banks: undefined,
};

function RenderDropdownActions({ onEdit, onDelete, index }) {
  return (
    <UncontrolledDropdown>
      <DropdownToggle color="link" size="lg" className={style.dropdown}>
        <i className="icon-options-vertical icons d-block" />
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => onEdit(index)}>
          <i className="fa fa-edit" />
          Edit
        </DropdownItem>
        <DropdownItem onClick={() => onDelete(index)}>
          <i className="fa fa-trash" />
          Delete
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

RenderDropdownActions.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default BankAccountsTab;
